import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import Logo from '@/components/Logo';
import Footer from '@/components/Footer';
import { REGISTER } from '@/constants/testIds';

export default function Register() {
	const { registerEmail, formatApiError } = useAuth();
	const navigate = useNavigate();
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [pw, setPw] = useState('');
	const [pw2, setPw2] = useState('');
	const [submitting, setSubmitting] = useState(false);

	const submit = async (e) => {
		e.preventDefault();
		if (pw !== pw2) {
			toast.error('Passwords do not match');
			return;
		}
		setSubmitting(true);
		try {
			await registerEmail(name.trim(), email.trim(), pw);
			toast.success('Welcome to MyFamShield');
			navigate('/dashboard');
		} catch (err) {
			toast.error(formatApiError(err, 'Could not create account'));
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center mesh-bg px-4 py-10">
			<div className="w-full max-w-md card-soft p-8">
				<Logo />
				<h2 className="mt-6 text-3xl font-heading font-bold tracking-tight text-slate-900">Create your family account</h2>
				<p className="mt-2 text-slate-600">A safer family starts with a single small step.</p>

				<form onSubmit={submit} className="mt-8 space-y-4">
					<div>
						<Label htmlFor="name">Name</Label>
						<Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid={REGISTER.nameInput} className="h-12 rounded-xl mt-1.5" placeholder="What should we call you?" />
					</div>
					<div>
						<Label htmlFor="email">Email</Label>
						<Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid={REGISTER.emailInput} className="h-12 rounded-xl mt-1.5" placeholder="you@family.com" />
					</div>
					<div>
						<Label htmlFor="pw">Password</Label>
						<Input id="pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid={REGISTER.passwordInput} className="h-12 rounded-xl mt-1.5" placeholder="At least 6 characters" />
					</div>
					<div>
						<Label htmlFor="pw2">Confirm password</Label>
						<Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid={REGISTER.passwordConfirmInput} className="h-12 rounded-xl mt-1.5" placeholder="Repeat password" />
					</div>
					<Button type="submit" disabled={submitting} data-testid={REGISTER.submitButton} className="w-full h-12 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white font-semibold">
						{submitting ? 'Creating…' : 'Create account'}
					</Button>
				</form>

				<p className="mt-6 text-sm text-slate-600 text-center">
					Already a family?{' '}
					<Link to="/login" data-testid={REGISTER.loginLink} className="font-semibold text-emerald-700 hover:underline">Sign in</Link>
				</p>
			</div>
			<Footer compact className="mt-8" />
		</div>
	);
}
